import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useSetDefaultEmailOptions } from 'shared/components/dashboard-mail-editor/hooks/use-set-default-email-options';
import { DisclosureBox } from 'shared/components/disclosure-box';
import { twMerge } from 'tailwind-merge';
import AttachmentsBlock from './components/attachments-block';
import ContactsSettingsBlock from './components/contacts-settings-block';
import EditorBlock from './components/editor-block';
import EmailSettingsBlock from './components/email-settings-block';
import SubstitutesBlock from './components/substitutes-block';
import { DashboardMailEditorProps, ExtendedState } from './types/common';
const DashboardMailEditor = t0 => {
  const $ = _c(61);
  const {
    additionalSubstitutes,
    attachmentsTempState,
    contactsSettings,
    errors,
    inModal,
    disabled,
    isPreFetching,
    isSwitchEditorButtonShown,
    onChangeContactsSettings,
    onChangeEmail,
    setAttachmentsTempState,
    showSettingsLink,
    sidebarItemBlock,
    switchEditorButtonProps,
    tempState,
    withContactsSettings,
    withRecipient,
    mailingId,
    withoutAttachments
  } = t0;
  let t1;
  if ($[0] !== withRecipient) {
    t1 = {
      withRecipient
    };
    $[0] = withRecipient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isOptionsApplied
  } = useSetDefaultEmailOptions(tempState, onChangeEmail, t1);
  let t2;
  if ($[2] !== errors.common) {
    t2 = errors.common && <>{errors.common.map(_temp)}</>;
    $[2] = errors.common;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isPreFetching || !isOptionsApplied;
  let t4;
  if ($[4] !== additionalSubstitutes || $[5] !== disabled || $[6] !== errors || $[7] !== inModal || $[8] !== isSwitchEditorButtonShown || $[9] !== mailingId || $[10] !== onChangeEmail || $[11] !== showSettingsLink || $[12] !== switchEditorButtonProps || $[13] !== t3 || $[14] !== tempState || $[15] !== withRecipient) {
    t4 = <div className="min-w-0 lg:h-auto lg:basis-3/4"><EditorBlock additionalSubstitutes={additionalSubstitutes} isSwitchEditorButtonShown={isSwitchEditorButtonShown} switchEditorButtonProps={switchEditorButtonProps} isPreFetching={t3} disabled={disabled} tempState={tempState} withRecipient={withRecipient} onChangeEmail={onChangeEmail} inModal={inModal} errors={errors} showSettingsLink={showSettingsLink} mailingId={mailingId} /></div>;
    $[4] = additionalSubstitutes;
    $[5] = disabled;
    $[6] = errors;
    $[7] = inModal;
    $[8] = isSwitchEditorButtonShown;
    $[9] = mailingId;
    $[10] = onChangeEmail;
    $[11] = showSettingsLink;
    $[12] = switchEditorButtonProps;
    $[13] = t3;
    $[14] = tempState;
    $[15] = withRecipient;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const t5 = inModal && (withRecipient ? "lg:pt-[24px]" : "lg:pt-[28px]");
  let t6;
  if ($[17] !== t5) {
    t6 = twMerge("static top-5 flex h-fit flex-col gap-5 sm:min-w-[320px] lg:sticky lg:basis-1/4", t5);
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const t7 = isPreFetching || !isOptionsApplied;
  let t8;
  if ($[19] !== disabled || $[20] !== errors || $[21] !== inModal || $[22] !== onChangeEmail || $[23] !== t7 || $[24] !== tempState) {
    t8 = <EmailSettingsBlock disabled={disabled} isPreFetching={t7} tempState={tempState} onChangeEmail={onChangeEmail} inModal={inModal} errors={errors} />;
    $[19] = disabled;
    $[20] = errors;
    $[21] = inModal;
    $[22] = onChangeEmail;
    $[23] = t7;
    $[24] = tempState;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== attachmentsTempState || $[27] !== disabled || $[28] !== errors.attachments || $[29] !== inModal || $[30] !== isPreFetching || $[31] !== mailingId || $[32] !== setAttachmentsTempState || $[33] !== withoutAttachments) {
    t9 = !withoutAttachments && <AttachmentsBlock disabled={disabled} isPreFetching={isPreFetching} attachmentsTempState={attachmentsTempState} setAttachmentsTempState={setAttachmentsTempState} inModal={inModal} mailingId={mailingId} errors={errors?.attachments} />;
    $[26] = attachmentsTempState;
    $[27] = disabled;
    $[28] = errors.attachments;
    $[29] = inModal;
    $[30] = isPreFetching;
    $[31] = mailingId;
    $[32] = setAttachmentsTempState;
    $[33] = withoutAttachments;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] !== inModal || $[36] !== sidebarItemBlock) {
    t10 = sidebarItemBlock && <DisclosureBox wrapperClassName={twMerge(inModal && "border border-text-secondary/30 rounded-lg", sidebarItemBlock.showErrorOutline && "border-danger")} title={<b className="text-text-primary text-start text-[17px]">{sidebarItemBlock.title}</b>}>{sidebarItemBlock.Component}</DisclosureBox>;
    $[35] = inModal;
    $[36] = sidebarItemBlock;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== contactsSettings || $[39] !== disabled || $[40] !== inModal || $[41] !== isPreFetching || $[42] !== onChangeContactsSettings || $[43] !== withContactsSettings) {
    t11 = withContactsSettings && <ContactsSettingsBlock disabled={disabled} isPreFetching={isPreFetching} contactsSettings={contactsSettings} onChangeContactsSettings={onChangeContactsSettings} inModal={inModal} />;
    $[38] = contactsSettings;
    $[39] = disabled;
    $[40] = inModal;
    $[41] = isPreFetching;
    $[42] = onChangeContactsSettings;
    $[43] = withContactsSettings;
    $[44] = t11;
  } else {
    t11 = $[44];
  }
  let t12;
  if ($[45] !== additionalSubstitutes || $[46] !== inModal) {
    t12 = <SubstitutesBlock inModal={inModal} additionalSubstitutes={additionalSubstitutes} />;
    $[45] = additionalSubstitutes;
    $[46] = inModal;
    $[47] = t12;
  } else {
    t12 = $[47];
  }
  let t13;
  if ($[48] !== t10 || $[49] !== t11 || $[50] !== t12 || $[51] !== t6 || $[52] !== t8 || $[53] !== t9) {
    t13 = <div className={t6}>{t8}{t9}{t10}{t11}{t12}</div>;
    $[48] = t10;
    $[49] = t11;
    $[50] = t12;
    $[51] = t6;
    $[52] = t8;
    $[53] = t9;
    $[54] = t13;
  } else {
    t13 = $[54];
  }
  let t14;
  if ($[55] !== t13 || $[56] !== t4) {
    t14 = <div className="flex flex-col gap-5 lg:flex-row">{t4}{t13}</div>;
    $[55] = t13;
    $[56] = t4;
    $[57] = t14;
  } else {
    t14 = $[57];
  }
  let t15;
  if ($[58] !== t14 || $[59] !== t2) {
    t15 = <div className="flex flex-col gap-3">{t2}{t14}</div>;
    $[58] = t14;
    $[59] = t2;
    $[60] = t15;
  } else {
    t15 = $[60];
  }
  return t15;
};
export default DashboardMailEditor;
function _temp(error, index) {
  return <p className="text-danger px-6 text-center text-sm" key={index}>{error}</p>;
}